import { create, update } from '@/api/request'

const STAGE_LINE_URL = 'consignment/status-lines'

export default {
  create: (data) => create(STAGE_LINE_URL, data),
  update: (id, data) => update(STAGE_LINE_URL, id, data)
}
